function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.date.to-iso-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import { Button, Card, Combobox, DescriptionList, Dialog, Flex, Notice, Select, Stepper, Text, createDatePickerValidator, createForm, useId, useToasts } from '@applyboard/crystal-ui';
import { addYears, sub } from 'date-fns';
import { ProgramType, generateIntakeOptions, useApplication, useApplicationAvailableActions, useApplicationPagePermissions, useLegacyApplicationRequirements, useLegacyApplication } from "../../data";
import { ArrowLeftOutlineIcon, ArrowRightOutlineIcon, SearchOutlineIcon } from '@applyboard/ui-icons';
import { useDebouncedState, useEventTracker } from '@applyboard/ui-utils';
import { usePrograms } from "../../data/programs";
import { useState } from 'react';
import { useLoadAggregatedData } from "./data";
import { EligibilityResults, getEligibilityNoticeIntent } from "../../../../components/EligibilityResult";
import { validateEslIntake } from "../../utils";
import { IntakeInfoCard } from "../../../../components/IntakeInfoCard";
import { TimelessDateStringInput } from "../../../../components/TimelessDateStringInput";
import { useLegacySendApplicationAction } from "../../data/actions";
import { SuccessMessage } from "../../../../components/SuccessMessage";
import { RequirementDeadlinesTable, getRelevantRequirements } from "../../../../components/RequirementDeadlinesTable";
import { isEqual } from 'lodash';
import { ApplicationActionName } from "../../../../types";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
var _createForm = createForm({
    provider: true
  }),
  FormProvider = _createForm.FormProvider,
  Form = _createForm.Form,
  Field = _createForm.Field,
  useFieldValues = _createForm.useFieldValues,
  useSetFieldValues = _createForm.useSetFieldValues,
  useTriggerValidation = _createForm.useTriggerValidation;
var maxDate = addYears(new Date(), 5);
var minDate = sub(new Date(), {
  months: 8
});
var validateDatePicked = createDatePickerValidator(minDate, maxDate, 'day');
export var ChangeProgramModal = function ChangeProgramModal(props) {
  if (!props.isOpen) {
    return null;
  }
  return _jsx(ChangeProgramModalContents, _objectSpread({}, props));
};
var ChangeProgramModalContents = function ChangeProgramModalContents(_ref) {
  var isOpen = _ref.isOpen,
    onOpenChange = _ref.onOpenChange,
    _onSuccess = _ref.onSuccess;
  var formId = useId();
  var _useLegacyApplication = useLegacyApplicationRequirements(),
    applicationRequirements = _useLegacyApplication.applicationRequirements;
  var requirementsWithDeadlines = getRelevantRequirements(applicationRequirements);
  var defaultValues = {
    programId: '',
    eslIntake: '',
    academicIntake: '',
    eslActualStartDate: '',
    eslActualAlternateStartDate: '',
    academicActualStartDate: '',
    academicActualAlternateStartDate: '',
    requirementDeadlines: requirementsWithDeadlines.map(function (requirement) {
      return {
        requirementId: requirement.id,
        deadline: requirement.deadline || ''
      };
    })
  };
  var _useLoadAggregatedDat = useLoadAggregatedData(),
    isLoadingAggregatedData = _useLoadAggregatedDat.isLoadingAggregatedData,
    loadAggregatedData = _useLoadAggregatedDat.loadAggregatedData,
    aggregatedData = _useLoadAggregatedDat.aggregatedData,
    isLoadingAggregatedDataError = _useLoadAggregatedDat.isLoadingAggregatedDataError;
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  var _useLegacySendApplica = useLegacySendApplicationAction(),
    sendApplicationAction = _useLegacySendApplica.sendApplicationAction,
    isSendingApplicationAction = _useLegacySendApplica.isSendingApplicationAction;
  var toasts = useToasts();
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  return _jsx(FormProvider, {
    defaultValues: defaultValues,
    onSubmit: function onSubmit(values) {
      var _aggregatedData$eslPr;
      trackEvent({
        event: 'Single Application - Change Program - Submitted Change Program Modal'
      });
      sendApplicationAction({
        actionId: 'change_program',
        actionData: {
          academicProgramId: values.programId,
          eslProgramId: aggregatedData === null || aggregatedData === void 0 ? void 0 : (_aggregatedData$eslPr = aggregatedData.eslProgram) === null || _aggregatedData$eslPr === void 0 ? void 0 : _aggregatedData$eslPr.id,
          academicIntake: values.academicIntake,
          academicActualStartDate: values.academicActualStartDate || null,
          academicActualAlternateStartDate: values.academicActualAlternateStartDate || null,
          eslIntake: values.eslIntake || null,
          eslActualStartDate: values.eslActualStartDate || null,
          eslActualAlternateStartDate: values.eslActualAlternateStartDate || null,
          requirementDeadlines: values.requirementDeadlines.filter(function (item) {
            var requirement = requirementsWithDeadlines.find(function (r) {
              return r.id === item.requirementId;
            });
            return item.deadline !== (requirement === null || requirement === void 0 ? void 0 : requirement.deadline);
          }).map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              deadline: item.deadline || null
            });
          })
        }
      }, {
        onSuccess: function onSuccess() {
          setStep(4);
          trackEvent({
            event: 'Single Application - Change Program - Successfully Changed Program'
          });
          _onSuccess();
        },
        onError: function onError(err) {
          toasts.negative(err instanceof Error ? err : new Error('Unknown error'));
        }
      });
    },
    children: _jsxs(Dialog, {
      open: isOpen,
      onOpenChange: onOpenChange,
      size: step === 4 ? 'md' : 'lg',
      children: [_jsx(Dialog.Heading, {
        children: step < 4 ? 'Change Program' : 'Program Successfully Changed'
      }), _jsx(Dialog.Content, {
        children: _jsx(Form, {
          id: formId,
          children: _jsx(ChangeProgramFormContents, {
            formId: formId,
            aggregatedData: aggregatedData,
            isLoadingAggregatedData: isLoadingAggregatedData,
            loadAggregatedData: loadAggregatedData,
            isLoadingAggregatedDataError: isLoadingAggregatedDataError,
            isSendingApplicationAction: isSendingApplicationAction,
            step: step,
            onStepChange: setStep,
            onClose: function onClose() {
              return onOpenChange(false);
            },
            defaultValues: defaultValues
          })
        })
      }), _jsx(Dialog.Actions, {
        children: _jsx(DialogActions, {
          step: step,
          onStepChange: setStep,
          isLoadingAggregatedData: isLoadingAggregatedData,
          aggregatedData: aggregatedData,
          isSendingApplicationAction: isSendingApplicationAction,
          formId: formId,
          onClose: function onClose() {
            return onOpenChange(false);
          }
        })
      })]
    })
  });
};
var ChangeProgramFormContents = function ChangeProgramFormContents(_ref2) {
  var aggregatedData = _ref2.aggregatedData,
    loadAggregatedData = _ref2.loadAggregatedData,
    isLoadingAggregatedData = _ref2.isLoadingAggregatedData,
    isLoadingAggregatedDataError = _ref2.isLoadingAggregatedDataError,
    step = _ref2.step,
    defaultValues = _ref2.defaultValues;
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedProgram = _useState4[0],
    setSelectedProgram = _useState4[1];
  var _useLegacyApplication2 = useLegacyApplication(),
    legacyApplication = _useLegacyApplication2.legacyApplication;
  var setFieldValues = useSetFieldValues();
  var currentAcademicProgram = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Main;
  });
  var currentEslProgram = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Esl;
  });
  if (!currentAcademicProgram) {
    throw new Error('Could not find academic program');
  }
  var _ref3 = aggregatedData || {},
    eligibilityDetails = _ref3.eligibilityDetails,
    eligibilityPermissions = _ref3.eligibilityPermissions,
    academicIntakes = _ref3.academicIntakes,
    eslIntakes = _ref3.eslIntakes,
    eslProgram = _ref3.eslProgram;
  return _jsxs(_Fragment, {
    children: [step === 1 && _jsx(SelectProgramStep, {
      selectedProgram: selectedProgram,
      onSelectProgram: function onSelectProgram(newProgram) {
        setSelectedProgram(newProgram);
        loadAggregatedData({
          programId: newProgram === null || newProgram === void 0 ? void 0 : newProgram.id,
          studentId: application.student.id.toString(),
          applicationId: application.id
        }, {
          onSuccess: function onSuccess(data) {
            var _data$eslIntakes, _data$eslIntakes$find, _data$academicIntakes, _data$academicIntakes2;
            var eslIntakeId = data !== null && data !== void 0 && data.eslProgram ? data === null || data === void 0 ? void 0 : (_data$eslIntakes = data.eslIntakes) === null || _data$eslIntakes === void 0 ? void 0 : (_data$eslIntakes$find = _data$eslIntakes.find(function (intake) {
              return intake.startDate === (currentEslProgram === null || currentEslProgram === void 0 ? void 0 : currentEslProgram.intake.startDate);
            })) === null || _data$eslIntakes$find === void 0 ? void 0 : _data$eslIntakes$find.intakeId.toString() : null;
            setFieldValues({
              eslIntake: eslIntakeId || '',
              eslActualStartDate: eslIntakeId ? (currentEslProgram === null || currentEslProgram === void 0 ? void 0 : currentEslProgram.actualStartDate) || '' : '',
              eslActualAlternateStartDate: eslIntakeId ? (currentEslProgram === null || currentEslProgram === void 0 ? void 0 : currentEslProgram.alternativeStartDate) || '' : '',
              academicIntake: (data === null || data === void 0 ? void 0 : (_data$academicIntakes = data.academicIntakes) === null || _data$academicIntakes === void 0 ? void 0 : (_data$academicIntakes2 = _data$academicIntakes.find(function (intake) {
                return intake.startDate === currentAcademicProgram.intake.startDate;
              })) === null || _data$academicIntakes2 === void 0 ? void 0 : _data$academicIntakes2.intakeId.toString()) || '',
              academicActualStartDate: currentAcademicProgram.actualStartDate || '',
              academicActualAlternateStartDate: currentAcademicProgram.alternativeStartDate || ''
            });
          }
        });
      },
      isLoadingAggregatedData: isLoadingAggregatedData,
      eligibilityDetails: eligibilityDetails,
      eligibilityPermissions: eligibilityPermissions,
      isLoadingAggregatedDataError: isLoadingAggregatedDataError,
      hasAcademicIntakes: Boolean(academicIntakes === null || academicIntakes === void 0 ? void 0 : academicIntakes.length)
    }), step === 2 && _jsx(UpdateIntakesStep, {
      eslIntakes: eslIntakes,
      academicIntakes: academicIntakes,
      eslProgram: eslProgram,
      selectedProgram: selectedProgram
    }), step === 3 && _jsx(UpdateRequirementDeadlinesStep, {
      selectedProgram: selectedProgram,
      defaultValues: defaultValues
    }), step == 4 && _jsx(SuccessMessageStep, {})]
  });
};
var SelectProgramStep = function SelectProgramStep(_ref4) {
  var _legacyApplication$pr;
  var selectedProgram = _ref4.selectedProgram,
    onSelectProgram = _ref4.onSelectProgram,
    isLoadingAggregatedData = _ref4.isLoadingAggregatedData,
    eligibilityDetails = _ref4.eligibilityDetails,
    eligibilityPermissions = _ref4.eligibilityPermissions,
    isLoadingAggregatedDataError = _ref4.isLoadingAggregatedDataError,
    hasAcademicIntakes = _ref4.hasAcademicIntakes;
  var _useApplication2 = useApplication(),
    application = _useApplication2.application;
  var _useLegacyApplication3 = useLegacyApplication(),
    legacyApplication = _useLegacyApplication3.legacyApplication;
  var _useDebouncedState = useDebouncedState((selectedProgram === null || selectedProgram === void 0 ? void 0 : selectedProgram.id) || ''),
    _useDebouncedState2 = _slicedToArray(_useDebouncedState, 3),
    debouncedSearchQuery = _useDebouncedState2[1],
    setSearchQuery = _useDebouncedState2[2];
  var _useApplicationPagePe = useApplicationPagePermissions(),
    permissions = _useApplicationPagePe.permissions;
  var _usePrograms = usePrograms({
      searchQuery: debouncedSearchQuery,
      schoolGroupId: permissions !== null && permissions !== void 0 && permissions.change_application_program_outside_original_school_group ? undefined : legacyApplication.schoolGroupId
    }),
    programs = _usePrograms.programs,
    schools = _usePrograms.schools,
    isProgramsError = _usePrograms.isProgramsError;
  var currentProgramId = (_legacyApplication$pr = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Main;
  })) === null || _legacyApplication$pr === void 0 ? void 0 : _legacyApplication$pr.programId;
  return _jsxs(Flex, {
    direction: "column",
    gap: 4,
    children: [_jsx(ChangeProgramStepper, {
      step: 1
    }), _jsx(ProgramInfoCard, {
      selectedProgram: selectedProgram
    }), _jsx(Text, {
      variant: "bodyM",
      intent: "secondary",
      children: "Please select a program to check applicant\u2019s eligibility and move forward with the program change."
    }), _jsx(Field, {
      as: Combobox,
      name: "programId",
      leadIcon: SearchOutlineIcon,
      label: "Program",
      onChange: function onChange(programId) {
        return onSelectProgram((programs === null || programs === void 0 ? void 0 : programs.find(function (program) {
          return program.id === programId;
        })) || null);
      },
      disabled: isLoadingAggregatedData,
      onSearch: setSearchQuery,
      validate: function validate(value) {
        return !value ? 'Please select a program' : true;
      },
      filterOption: function filterOption(option, query) {
        return option.label.toLowerCase().includes(query.trim().toLowerCase());
      },
      placeholder: "Enter program name or ID",
      children: schools !== null && schools !== void 0 && schools.length ? schools.map(function (school) {
        return _jsx(Combobox.OptionGroup, {
          label: school.attributes.name,
          groupValue: school.attributes.name,
          children: programs === null || programs === void 0 ? void 0 : programs.filter(function (program) {
            return program.schoolId.toString() === school.id && Number(program.id) !== currentProgramId;
          }).map(function (program) {
            return _jsx(Combobox.Option, {
              label: "[".concat(program.id, "] ").concat(program.name),
              value: program.id
            }, program.id);
          })
        }, school.id);
      }) : programs === null || programs === void 0 ? void 0 : programs.map(function (program) {
        return _jsx(Combobox.Option, {
          label: "[".concat(program.id, "] ").concat(program.name),
          value: program.id
        }, program.id);
      })
    }), eligibilityDetails && _jsx(EligibilityResults, {
      eligibilityStatus: eligibilityDetails.eligibility,
      eligibilityPermissions: eligibilityPermissions,
      eligibilityDetails: eligibilityDetails,
      selectedStudent: {
        id: application.student.id.toString(),
        name: application.student.fullName
      },
      blockBecauseNoIntakes: !hasAcademicIntakes
    }), _jsx("div", {
      role: "status",
      "aria-live": "polite",
      children: (isProgramsError || isLoadingAggregatedDataError) && _jsx(Notice, {
        intent: "negative",
        children: "Your request cannot be completed due to an error on our end. Please try again in a few minutes. If the error persists feel free to contact our support team."
      })
    })]
  });
};
var ChangeProgramStepper = function ChangeProgramStepper(_ref5) {
  var step = _ref5.step;
  return _jsxs(Stepper, {
    activeStep: step - 1,
    "aria-label": "Change program steps",
    children: [_jsx(Stepper.Step.Title, {
      children: "Program"
    }), _jsx(Stepper.Step.Title, {
      children: "Intakes"
    }), _jsx(Stepper.Step.Title, {
      children: "Requirement deadlines"
    })]
  });
};
var DialogActions = function DialogActions(_ref6) {
  var step = _ref6.step,
    onStepChange = _ref6.onStepChange,
    isLoadingAggregatedData = _ref6.isLoadingAggregatedData,
    aggregatedData = _ref6.aggregatedData,
    formId = _ref6.formId,
    isSendingApplicationAction = _ref6.isSendingApplicationAction,
    onClose = _ref6.onClose;
  var triggerValidation = useTriggerValidation();
  var _ref7 = aggregatedData || {},
    academicIntakes = _ref7.academicIntakes,
    eligibilityDetails = _ref7.eligibilityDetails,
    eligibilityPermissions = _ref7.eligibilityPermissions;
  return _jsxs(_Fragment, {
    children: [step < 4 && _jsx(Dialog.CloseButton, {
      children: "Cancel"
    }), step === 1 && _jsx(Button, {
      intent: "primary",
      trailIcon: ArrowRightOutlineIcon,
      disabled: isLoadingAggregatedData,
      onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return triggerValidation();
            case 2:
              _context.t0 = _context.sent;
              if (!_context.t0) {
                _context.next = 5;
                break;
              }
              _context.t0 = getEligibilityNoticeIntent({
                eligibilityStatus: eligibilityDetails === null || eligibilityDetails === void 0 ? void 0 : eligibilityDetails.eligibility,
                eligibilityPermissions: eligibilityPermissions,
                blockBecauseNoIntakes: !(academicIntakes !== null && academicIntakes !== void 0 && academicIntakes.length)
              }) !== 'negative';
            case 5:
              if (!_context.t0) {
                _context.next = 8;
                break;
              }
              onStepChange(2);
              return _context.abrupt("return");
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })),
      children: "Next"
    }), step === 2 && _jsxs(Flex, {
      gap: 2,
      children: [_jsx(Button, {
        intent: "primary",
        leadIcon: ArrowLeftOutlineIcon,
        emphasis: "outlined",
        onClick: function onClick() {
          onStepChange(1);
        },
        children: "Previous"
      }), _jsx(Button, {
        intent: "primary",
        trailIcon: ArrowRightOutlineIcon,
        onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return triggerValidation();
              case 2:
                if (!_context2.sent) {
                  _context2.next = 4;
                  break;
                }
                onStepChange(3);
              case 4:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        })),
        children: "Next"
      })]
    }), step === 3 && _jsxs(Flex, {
      gap: 2,
      children: [_jsx(Button, {
        intent: "primary",
        leadIcon: ArrowLeftOutlineIcon,
        emphasis: "outlined",
        onClick: function onClick() {
          onStepChange(2);
        },
        children: "Previous"
      }), _jsx(Button, {
        intent: "primary",
        type: "submit",
        form: formId,
        loading: isSendingApplicationAction,
        children: "Change program"
      })]
    }), step === 4 && _jsx(Button, {
      intent: "primary",
      width: "fill",
      onClick: onClose,
      children: "OK"
    })]
  });
};
var UpdateIntakesStep = function UpdateIntakesStep(_ref10) {
  var _action$additionalInf;
  var academicIntakes = _ref10.academicIntakes,
    eslIntakes = _ref10.eslIntakes,
    eslProgram = _ref10.eslProgram,
    selectedProgram = _ref10.selectedProgram;
  var _useApplicationAvaila = useApplicationAvailableActions(),
    getApplicationAvailableAction = _useApplicationAvaila.getApplicationAvailableAction;
  var _useLegacyApplication4 = useLegacyApplication(),
    legacyApplication = _useLegacyApplication4.legacyApplication;
  var currentAcademicProgram = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Main;
  });
  var currentEslProgram = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Esl;
  });
  if (!currentAcademicProgram) {
    throw new Error('Could not find academic program');
  }
  var action = getApplicationAvailableAction(ApplicationActionName.CHANGE_PROGRAM);
  var showStartDates = action === null || action === void 0 ? void 0 : (_action$additionalInf = action.additionalInformation) === null || _action$additionalInf === void 0 ? void 0 : _action$additionalInf.startDateUpdateAllowed;
  var hasEsl = Boolean(eslProgram);
  return _jsxs(Flex, {
    direction: "column",
    gap: 4,
    children: [_jsx(ChangeProgramStepper, {
      step: 2
    }), _jsx(ProgramInfoCard, {
      selectedProgram: selectedProgram
    }), _jsxs(Text, {
      children: ["Please select program intakes to be able to move forward with the program change.", ' ', showStartDates && 'Actual start dates and alternative start dates may be selected as well.']
    }), _jsxs(Flex, {
      direction: "column",
      gap: 2,
      children: [_jsx(Field, {
        as: Select,
        label: "ESL intake",
        name: "eslIntake",
        validate: function validate(value, _ref11) {
          var _eslIntakes$find, _academicIntakes$find;
          var values = _ref11.values,
            triggerValidation = _ref11.triggerValidation;
          var eslIntakeStartDate = (eslIntakes === null || eslIntakes === void 0 ? void 0 : (_eslIntakes$find = eslIntakes.find(function (intake) {
            return intake.intakeId === value;
          })) === null || _eslIntakes$find === void 0 ? void 0 : _eslIntakes$find.startDate) || '';
          var academicIntakeStartDate = (academicIntakes === null || academicIntakes === void 0 ? void 0 : (_academicIntakes$find = academicIntakes.find(function (intake) {
            return intake.intakeId === values.academicIntake;
          })) === null || _academicIntakes$find === void 0 ? void 0 : _academicIntakes$find.startDate) || '';
          triggerValidation('eslActualStartDate');
          var isEslIntakeValid = validateEslIntake({
            eslProgram: eslProgram,
            eslIntake: eslIntakeStartDate,
            academicIntake: academicIntakeStartDate
          });
          return isEslIntakeValid;
        },
        disabled: !hasEsl,
        appearance: "styled",
        children: eslIntakes && generateIntakeOptions({
          selectedIntake: currentEslProgram === null || currentEslProgram === void 0 ? void 0 : currentEslProgram.intake.startDate,
          intakes: eslIntakes,
          useIds: true
        }).map(function (_ref12, index) {
          var label = _ref12.label,
            value = _ref12.value;
          return _jsx(Select.Option, {
            label: label,
            value: value
          }, index);
        })
      }), showStartDates ? _jsxs(Flex, {
        direction: "column",
        gap: 4,
        children: [_jsx(EslInfoCard, {
          hideDates: true,
          eslIntakes: eslIntakes
        }), _jsxs(Flex, {
          direction: "row",
          justify: "between",
          gap: 4,
          children: [_jsx(Field, {
            as: TimelessDateStringInput,
            label: "ESL start date",
            name: "eslActualStartDate",
            maxDate: maxDate.toISOString(),
            minDate: minDate.toISOString(),
            size: "lg",
            disabled: !hasEsl,
            validate: function validate(value, _ref13) {
              var values = _ref13.values;
              if (values.eslIntake !== '' && value === '') {
                return 'ESL actual start date cannot be left empty since an ESL intake is currently specified.';
              }
              if (value === '') {
                return true;
              }
              return validateDatePicked(value);
            }
          }), _jsx(Field, {
            as: TimelessDateStringInput,
            label: "Alternative ESL start date",
            name: "eslActualAlternateStartDate",
            maxDate: maxDate.toISOString(),
            minDate: minDate.toISOString(),
            size: "lg",
            disabled: !hasEsl
          })]
        })]
      }) : _jsx(EslInfoCard, {
        eslIntakes: eslIntakes
      })]
    }), _jsxs(Flex, {
      direction: "column",
      gap: 2,
      children: [_jsx(Field, {
        as: Select,
        label: "Academic intake",
        name: "academicIntake",
        appearance: "styled",
        validate: function validate(value, _ref14) {
          var triggerValidation = _ref14.triggerValidation;
          triggerValidation('eslIntake');
          return true;
        },
        required: "Please enter an academic intake",
        children: academicIntakes && generateIntakeOptions({
          selectedIntake: currentAcademicProgram.intake.startDate,
          intakes: academicIntakes,
          useIds: true
        }).map(function (_ref15, index) {
          var label = _ref15.label,
            value = _ref15.value;
          return _jsx(Select.Option, {
            label: label,
            value: value
          }, index);
        })
      }), showStartDates ? _jsxs(Flex, {
        direction: "column",
        gap: 4,
        children: [_jsx(AcademicInfoCard, {
          hideDates: true,
          academicIntakes: academicIntakes
        }), _jsxs(Flex, {
          direction: "row",
          justify: "between",
          gap: 4,
          children: [_jsx(Field, {
            as: TimelessDateStringInput,
            label: "Academic start date",
            name: "academicActualStartDate",
            maxDate: maxDate.toISOString(),
            minDate: minDate.toISOString(),
            size: "lg",
            validate: validateDatePicked,
            required: "Please enter an Academic start date"
          }), _jsx(Field, {
            as: TimelessDateStringInput,
            label: "Alternative academic start date",
            name: "academicActualAlternateStartDate",
            maxDate: maxDate.toISOString(),
            minDate: minDate.toISOString(),
            size: "lg"
          })]
        })]
      }) : _jsx(AcademicInfoCard, {
        academicIntakes: academicIntakes
      })]
    })]
  });
};
var EslInfoCard = function EslInfoCard(_ref16) {
  var hideDates = _ref16.hideDates,
    eslIntakes = _ref16.eslIntakes;
  var _useFieldValues = useFieldValues(['eslIntake']),
    eslIntake = _useFieldValues.eslIntake;
  if (!eslIntake || !eslIntakes) {
    return null;
  }
  return _jsx(IntakeInfoCard, {
    "aria-label": "ESL intake information",
    intakes: eslIntakes,
    intakeId: eslIntake,
    hideDates: hideDates
  });
};
var AcademicInfoCard = function AcademicInfoCard(_ref17) {
  var hideDates = _ref17.hideDates,
    academicIntakes = _ref17.academicIntakes;
  var _useFieldValues2 = useFieldValues(['academicIntake']),
    academicIntake = _useFieldValues2.academicIntake;
  if (!academicIntake || !academicIntakes) {
    return null;
  }
  return _jsx(IntakeInfoCard, {
    "aria-label": "Academic intake information",
    intakes: academicIntakes,
    intakeId: academicIntake,
    hideDates: hideDates
  });
};
var ProgramInfoCard = function ProgramInfoCard(_ref18) {
  var selectedProgram = _ref18.selectedProgram;
  var _useApplication3 = useApplication(),
    application = _useApplication3.application;
  return _jsx(Card, {
    "aria-label": "Change program information",
    children: _jsxs(DescriptionList, {
      variant: "grid",
      children: [_jsx(DescriptionList.Item, {
        term: "Student",
        details: "[".concat(application.student.id, "] ").concat(application.student.fullName),
        align: "start",
        justify: "start"
      }), selectedProgram && _jsx(DescriptionList.Item, {
        term: "Program",
        details: "[".concat(selectedProgram.id, "] ").concat(selectedProgram.name),
        align: "start",
        justify: "start"
      })]
    })
  });
};
function SuccessMessageStep() {
  var _legacyApplication$pr2;
  var _useLegacyApplication5 = useLegacyApplication(),
    legacyApplication = _useLegacyApplication5.legacyApplication;
  var academicProgramName = (_legacyApplication$pr2 = legacyApplication.programs.find(function (program) {
    return program.programType === 'main';
  })) === null || _legacyApplication$pr2 === void 0 ? void 0 : _legacyApplication$pr2.programName;
  return _jsxs(SuccessMessage, {
    children: [_jsxs(Text, {
      variant: "bodyM",
      intent: "secondary",
      children: ["Application's program has been successfully changed to \u201C", academicProgramName, "\u201D!"]
    }), _jsx(Text, {
      variant: "bodyM",
      intent: "secondary",
      children: "It's recommended to check the Compare Requirements view now to make sure all necessary requirements are active and available for the applicant."
    })]
  });
}
var UpdateRequirementDeadlinesStep = function UpdateRequirementDeadlinesStep(_ref19) {
  var selectedProgram = _ref19.selectedProgram,
    defaultValues = _ref19.defaultValues;
  return _jsxs(Flex, {
    direction: "column",
    gap: 4,
    children: [_jsx(ChangeProgramStepper, {
      step: 3
    }), _jsx(ProgramInfoCard, {
      selectedProgram: selectedProgram
    }), _jsx(Text, {
      children: "You\u2019re about to change the application\u2019s program. Please provide requirement deadlines to be able to move forward with the status update."
    }), _jsx(Field, {
      as: RequirementDeadlinesTable,
      name: "requirementDeadlines",
      validate: function validate(value) {
        var _iterator = _createForOfIteratorHelper(value),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var deadlineDate = _step.value;
            if (isEqual(value, defaultValues.requirementDeadlines)) {
              return true;
            }
            if (validateDatePicked(deadlineDate.deadline) !== true) {
              return 'All deadline dates must be within 8 months in the past and 5 years in the future';
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return true;
      },
      minDate: minDate,
      maxDate: maxDate
    })]
  });
};